// @ts-nocheck
import {
  FETCH_EVENTS_FULFILLED,
  FETCH_EVENTS_REJECTED,
  FETCH_CORRESPONDENCE_FULFILLED,
  FETCH_CORRESPONDENCE_REJECTED,
  FETCH_EMAILS_FULFILLED,
  FETCH_EMAILS_REJECTED,
  FETCH_EMAILS_URL_FULFILLED,
  FETCH_EMAILS_URL_REJECTED,
} from './eventActionTypes';

const initialState = {
  events: null,
  correspondence: null,
  emails: null,
  emailsUrl: null,
};

export default function eventReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EVENTS_FULFILLED:
      return {
        ...state,
        events: action.payload,
      };
    case FETCH_EVENTS_REJECTED:
      return {
        ...state,
        events: null,
      };
    case FETCH_CORRESPONDENCE_FULFILLED:
      return {
        ...state,
        correspondence: action.payload,
      };
    case FETCH_CORRESPONDENCE_REJECTED:
      return {
        ...state,
        correspondence: null,
      };
    case FETCH_EMAILS_FULFILLED:
      return {
        ...state,
        emails: action.payload,
      };
    case FETCH_EMAILS_REJECTED:
      return {
        ...state,
        emails: null,
      };
    case FETCH_EMAILS_URL_FULFILLED:
      return {
        ...state,
        emailsUrl: action.payload,
      };
    case FETCH_EMAILS_URL_REJECTED:
      return {
        ...state,
        emailsUrl: null,
      };
    default:
      return state;
  }
}
